<template>
  <v-card >
    <v-card-title>Händelser</v-card-title>
    <NotificationList />
  </v-card>
</template>

<script>
import API from '@/services/api'
import {mapGetters, mapActions} from 'vuex'
import {NotificationMixin} from '@/components/mixins'
import NotificationList from '@/components/Notifications/NotificationList'
// @group Common
// Notifications component
export default {
  name: 'Notifications',

  components: {
    NotificationList
  },

  props: {
    loadTime: Number
  },

  mixins: [NotificationMixin],

  created() {
    console.log('Notifications - created')
  },

  mounted() {
    console.log('Notifications - mounted')
  },

  computed: {
    ...mapGetters('currentuser', ['isLoggedIn', 'notifications']),
    ...mapGetters('app', ['isInitialized'])
  },

  methods: {
    ...mapActions('currentuser', ['setNotifications']),
    
     /**
     * @vuese
     * Used to read notifications if user is logged in
     * @arg The argument is an empty object 
     */
    readNotifications() {
      if (this.isLoggedIn && this.isInitialized) {
        API.readNotifications({data: {}})
          .then(response => {
            this.loadNotifications()
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
      }
    },
     /**
     * @vuese
     * Used to load notifications if user is logged in
     * @arg The argument is an object representing search criteries
     */
    loadNotifications() {
      console.log('Notifications - loadNotifications')
      API.listNotifications({
        startAt: 0,
        pageSize: 1000,
        sortBy: 'sentTime',
        sortDesc: true,
        search: ''
      })
        .then(response => {
          /**
           * @vuese
           * Used to set notifications to local store
           * @arg The argument is an array representing notifications list
           */
          this.setNotifications(response.data.rows)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style>
</style>